import React from 'react'

import cgdreamLogo from 'images/cgdream_icon_dark.svg'

import Link from './Components/Link'

const links = [{
  text: 'Generate Images with Flux Dev',
  href: 'https://cgdream.ai/features/free-flux-ai-image-generator',
}, {
  text: 'Text to Image AI',
  href: 'https://cgdream.ai/features/text-to-image-ai-generator',
}, {
  text: 'AI Photo Editor',
  href: 'https://cgdream.ai/features/ai-photo-editor',
}, {
  text: 'AI 3D Rendering',
  href: 'https://cgdream.ai/features/ai-3d-rendering',
}, {
  text: 'AI 3D Model Generator',
  href: 'https://cgdream.ai/features/ai-3d-model-generator-image-to-3d',
}, {
  text: 'AI Filters for Images',
  href: 'https://cgdream.ai/features/ai-filters-for-images ',
}, {
  text: 'AI Image Upscaler',
  href: 'https://cgdream.ai/features/ai-image-upscaler',
}, {
  text: 'AI Image Inpainting',
  href: 'https://cgdream.ai/features/ai-image-inpainting',
}]

/**
 * Server component that renders dropdown with links to cgdream.
 */

function Dropdown() {
  return (
    <div className="custom-fast-dropdown__inner">
      <div
        className="custom-fast-dropdown__top nav-options-dropdown__section nav-options-dropdown__section--highlighted"
      >
        <ul className="unstyled-list">
          <li className="user-menu-item">
            <a
              className="cgt-menu-item cgt-menu-item--medium cgt-menu-item--icon-left"
              href="https://cgdream.ai?utm_source=cgtrader&utm_medium=referral&utm_campaign=mymodels"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="cgt-menu-item__lead-icon">
                <div className="cgt-icon cgt-icon__icon cgt-icon--default">
                  <img src={cgdreamLogo} alt="CGDream" className="navbar-icon" />
                </div>
              </span>
              <span className="cgt-menu-item__text cgdream-nav-link">CGDream.ai</span>
            </a>
          </li>
        </ul>
      </div>
      <div className="custom-fast-dropdown__bottom nav-options-dropdown__section">
        <ul className="unstyled-list">
          {links.map(({ text, href }) => (
            <li className="user-menu-item" key={`ai-generator-link-${text}`}>
              <Link text={text} href={href} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Dropdown
